import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero legal-hero">
        <div className="page-hero-overlay legal-hero-overlay" />
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Terms of Service</h1>
            <p>Last updated: January 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div className="content-narrow mx-auto-narrow">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>1. Agreement to Terms</h2>
              <p>
                By accessing or using the Fasting Carnivore website and purchasing our products, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or purchase our products.
              </p>

              <h2>2. Products and Services</h2>
              <h3>Digital Products</h3>
              <p>
                Fasting Carnivore offers digital products including ebooks, guides, and educational materials. All products are delivered digitally and are available for immediate download or access upon purchase.
              </p>

              <h3>No Physical Products</h3>
              <p>
                We do not sell or ship physical products. All purchases are for digital content only.
              </p>

              <h2>3. Purchase and Payment</h2>
              <ul>
                <li>All prices are listed in US dollars unless otherwise specified</li>
                <li>Payment is processed securely through our third-party payment processor</li>
                <li>You will receive access to your purchased products immediately upon successful payment</li>
                <li>All sales are final (see Refund Policy below for exceptions)</li>
              </ul>

              <h2>4. Refund Policy</h2>
              <p>
                Due to the digital nature of our products, all sales are generally final. However, if you experience technical issues accessing your purchase, please contact us within 7 days of purchase and we will work to resolve the issue or provide a refund at our discretion.
              </p>

              <h2>5. Intellectual Property</h2>
              <p>
                All content on this website and in our products, including text, graphics, logos, images, and digital downloads, is the property of Fasting Carnivore and is protected by copyright laws.
              </p>
              <h3>You May:</h3>
              <ul>
                <li>Download and view purchased content for personal use</li>
                <li>Print copies for your personal, non-commercial use</li>
              </ul>
              <h3>You May Not:</h3>
              <ul>
                <li>Redistribute, share, or resell our products</li>
                <li>Upload our content to file-sharing sites</li>
                <li>Use our content for commercial purposes without permission</li>
                <li>Remove any copyright or proprietary notices</li>
              </ul>

              <h2>6. User Conduct</h2>
              <p>When using our website or community features, you agree not to:</p>
              <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Impersonate any person or entity</li>
                <li>Harass, abuse, or harm others</li>
                <li>Share false or misleading information</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use automated systems to access our website without permission</li>
              </ul>

              <h2>7. Disclaimer of Warranties</h2>
              <p>
                Our products and website are provided "as is" without warranties of any kind, either express or implied. We do not guarantee that our products will meet your specific needs or expectations.
              </p>

              <h2>8. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Fasting Carnivore shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our products or website.
              </p>

              <h2>9. Health Disclaimer</h2>
              <p>
                Our products are for informational and educational purposes only. They do not constitute medical advice. Always consult with a qualified healthcare provider before making any dietary or lifestyle changes. See our full Disclaimer for more information.
              </p>

              <h2>10. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Fasting Carnivore, its owners, employees, and affiliates from any claims, damages, or expenses arising from your use of our products or violation of these terms.
              </p>

              <h2>11. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of our website after changes constitutes acceptance of the modified terms.
              </p>

              <h2>12. Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law principles.
              </p>

              <h2>13. Contact Information</h2>
              <p>
                For questions about these Terms of Service, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> support@fastingcarnivore.com
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
